import React from "react";
import "./style.css";
import { useSelector } from "react-redux";

const QueNavigatorBox = ({ queNo }) => {
  const questions = useSelector((state) => state.answer);
  const smoothScrollTo = (elementId) => {
    const element = document.getElementById(elementId);
    const offset = 100;
    const topPosition =
      element.getBoundingClientRect().top + window.pageYOffset;
    window.scrollTo({ top: topPosition - offset, behavior: "smooth" });
  };


  return (
    <div
      className="mcqBox"
      onClick={() => smoothScrollTo(`question${queNo}`)}
      style={
        (questions && questions[queNo - 1])
          ? { backgroundColor: "var(--orange)", color: "#FEFFFE" }
          : {
            backgroundColor: "var(--background-color)",
            color: "var(--color)",
          }
      }
    >
      {queNo}
    </div>
  );
};

export default QueNavigatorBox;
